const routes = [{
  path: '/issuecontrol',
  component: () => import('@/views/issuecontrol'),
  name: 'issuecontrol',
  meta: {
    title: '报价风控'
  }
}, {
  path: '/issuecontrol/supplierId',
  component: () => import('@/views/issuecontrol/supplierId'),
  name: 'issuecontrol-supplierId',
  meta: {
    title: '报价风控'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/issuecontrol.js